module.exports = __webpack_public_path__ + "img/banner.421c0358.jpg";